import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { ParagraphProps } from '../../styledComponents';
import { getTierFormattedDate } from '../../../../../payments/SelectPackageForm/ProductType/ProductItem/ProductItem';
import { DAY_MONTH } from '../../../../../../constants';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectSiteHeaderData } from '../../../../../../store/features/siteHeader';

export type TierProps = {
  endDate: string;
  maxSaving: string;
  as: ComponentType<ParagraphProps>;
};

export function Tier(props: TierProps) {
  const { endDate, maxSaving, as: Component } = props;
  const { t } = useTranslation();
  const { dateFormat = DAY_MONTH } = useRootSelector(selectSiteHeaderData);

  return (
    <Component
      text={t(
        'site.modules.course-option-display.pricing.tier.save-by-date.label',
        { 0: getTierFormattedDate(endDate, dateFormat), 1: maxSaving },
      )}
    />
  );
}
